var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer-contact"
  }, _vm._l(_vm.contactList, function (item, index) {
    return _c('a', {
      key: index,
      staticClass: "icon-link",
      attrs: {
        "target": "_bank",
        "rel": "noopener noreferrer",
        "href": item.href,
        "title": item.name
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.name,
        "width": "100%",
        "height": "auto"
      }
    })]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };